import { render, staticRenderFns } from "./MyRelease.vue?vue&type=template&id=44b587dc&scoped=true&"
import script from "./MyRelease.vue?vue&type=script&lang=js&"
export * from "./MyRelease.vue?vue&type=script&lang=js&"
import style0 from "./MyRelease.vue?vue&type=style&index=0&id=44b587dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b587dc",
  null
  
)

export default component.exports